import { Span } from '@chakra-ui/react';
import { type Msg } from '@halo/chat-sdk-react';

export interface MsgUnknownContentProps {
  message: Msg;
}

export const MsgUnknownContent = memo(function MsgUnknownContent({
  message,
}: MsgUnknownContentProps) {
  const { t } = useTranslation();
  return (
    <Span color="fg.muted" fontSize="xs">
      {t('chat.unknownMessageText', { payloadType: message?.payload_type })}
    </Span>
  );
});
